if (!customElements.get('kik-pickpackage')) {
  class KikPickPackage extends HTMLElement {
    constructor() {
      super();
      this.onCardClick = this.onCardClick.bind(this);
      this.onCardKeydown = this.onCardKeydown.bind(this);
    }

    connectedCallback() {
      this.cards = this.querySelectorAll('[data-pick-package-card]');
      this.cards.forEach((card) => {
        card.addEventListener('click', this.onCardClick);
        card.addEventListener('keydown', this.onCardKeydown);
      });
    }

    disconnectedCallback() {
      this.cards?.forEach((card) => {
        card.removeEventListener('click', this.onCardClick);
        card.removeEventListener('keydown', this.onCardKeydown);
      });
    }

    onCardClick(event) {
      this.selectCard(event.currentTarget);
    }

    onCardKeydown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.selectCard(event.currentTarget);
      }
    }

    selectCard(card) {
      const quantity = parseInt(card.dataset.quantity, 10) || 1;

      // Update visual selection
      this.cards.forEach((c) =>
        c.classList.remove('kik-pick-package__card--selected')
      );
      card.classList.add('kik-pick-package__card--selected');

      // Find quantity input on the product form
      const section =
        this.closest('.js-product') || this.closest('[data-section]');
      if (!section) return;

      const qtyInput = section.querySelector('input[name="quantity"]');
      if (qtyInput) {
        qtyInput.value = quantity;
        // bubbling change/input triggers the sticky-atc sync listener
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  }

  customElements.define('kik-pickpackage', KikPickPackage);
}
